import { getLicense, License, DetailLicense } from '@/api/ping'
import { RootState, Module } from '../types'

export const license: Module<License, RootState> = {
  namespaced: true,
  state() {
    return {
      clientId: '',
      customerName: '',
      expire: '',
      hostName: '',
      licenseId: '',
      latitude: 0,
      longitude: 0,
      detailLicense: {
        customer: '',
        distributor: '',
        hawaNode: false,
        hawaServer: false,
        id: '',
        validity: '',
      } as DetailLicense,
    }
  },

  mutations: {
    UPDATE_LICENSE_INFO: (state, payload: License) => {
      state.clientId = payload.clientId
      state.customerName = payload.customerName
      state.expire = payload.expire
      state.hostName = payload.hostName
      state.licenseId = payload.licenseId
      state.latitude = payload.latitude
      state.longitude = payload.longitude
      state.detailLicense = payload.detailLicense
    },
  },

  actions: {
    async getLicense({ commit }) {
      const license = await getLicense()
      commit('UPDATE_LICENSE_INFO', license)
    },
  },
}
